//数据接口地址
// export const API_URL = 'http://8.131.233.130:90'
// export const API_URL = 'http://120.27.131.16:90'
export const API_URL = 'https://www.asfcyy.net:8080'
// export const API_URL = 'http://123.56.48.5:90'
